import React, { useState, useEffect, lazy } from 'react';
//const fs = require('fs');

import {useSelector} from 'react-redux';
import BackgroundImage from './BackgroundImage.js';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box'
import CustomizedBreadcrumbs from './Breadcrumbs.js';
import SplitButton2 from './splitButton2.js';


export default function FTPSettings({}){

  const { user } = useSelector((state) => state.auth); 
  const[dashboardName, setDashboardName] = useState("Dashboard"); // This "Dashboard" Vlaue will open the dashboard bydefault with name "Dashboard"
  const[widgetName, setWidgetName] = useState();
  //Import() to call function or component with dynamic path value
  let projectname = user.selectedproject;
  let dashboardType = "Email";

//Here.catch used, if dasboardName file does not exist then will display the BackgroundImage.js content to avoid the error.
//only accepting last name of file path as variable, otherwise giving error
  const ImportCompo = lazy(() => import(`./../pages/Email/${dashboardName}`).catch((err) => {  
  return import('./BackgroundImage.js');
  }),
  );


  const handleSelectedDashboard = (value) => {
    //console.log(value);
    setDashboardName(value);
  };

  const handleSelectedWidget = (value) => {
    //console.log(value);
    setWidgetName(value);
  };

 
  return (
    
    <div >
      {/* <Box sx={{height: 85 }}>  </Box> */}

        <Box sx={{mt:1, height: 50}} >
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{backgroundColor: 'transparent'}}>
          <Grid item xs={10}>           
            <CustomizedBreadcrumbs
            projectName={projectname}
            dashboardType={dashboardType}
            selectedDashboard = {handleSelectedWidget}
            />

          </Grid>
          <Grid item xs={2} justifyContent="center">
          {( user.role === "engineer"  || user.role === "superadmin") && (
          <SplitButton2
          projectName={projectname}
          dashboardType={dashboardType}
          selectedDashboard = {handleSelectedDashboard}
          />
          )}
          </Grid>
          
          
          {/* <Grid item xs={4}> <DateTimeDisplay/>  </Grid> */}
        </Grid>
        </Box>

      
      
    {/* Selected page or dashboard content */}

    {dashboardName ? (
      <React.Suspense fallback={<>...</>}>
      <ImportCompo/>
    </React.Suspense>
    ):(
      <BackgroundImage/>
    )}
        
    </div>


  );
}